import { imageUrl } from './image';
export const projectFilters = ['All', 'AI / ML', 'Backend', 'Web', 'Mobile'];

// Only these have real screenshots to show off — keeps "Selected work" curated instead of a wall of placeholders.
export const showcaseOrder = [
    'toolgenie',
    'ayozat',
    'zatlive',
    'rightsmint',
    'delivery-route',
    'shrimp',
    'robo-arm',
    'python-sinhala',
    'pascal-sinhala',
    'weddings',
];

export const projects = [
    {
        id: 'toolgenie',
        title: 'ToolGenie',
        seoTitle: 'ToolGenie AI Creator Platform | Lakshitha Perera',
        seoHeading: 'ToolGenie — AI Creator Platform',
        overline: 'AI Creator Platform · Tech Lead',
        category: 'AI / ML',
        featured: true,
        problem: 'Creators need faster ways to ideate, package and publish YouTube work.',
        solution: 'An AI-powered creator platform and Chrome extension for YouTube ideation, SEO, metadata and workflow automation.',
        role: 'Tech lead',
        architecture: 'Web platform with a Chrome extension (Manifest V3) for creator workflows.',
        technologies: ['Next.js', 'AI tools', 'Manifest V3'],
        challenges: '',
        result: '',
        image: '/work/Toolgenie.png',
        images: ['/work/Toolgenie.png', '/work/ToolgenieExtension.png'],
        links: [
            { label: 'Live', url: 'https://toolgenie.io/' },
            { label: 'LinkedIn', url: 'https://www.linkedin.com/in/lakshitha1629/' },
        ],
        github: '',
        demo: 'https://toolgenie.io/',
    },
    {
        id: 'ayozat',
        title: 'AYOZAT Stream',
        overline: 'Streaming & VOD Platform',
        category: 'Web',
        featured: true,
        problem: 'Streaming products need to work across live TV, VOD, monetization and mobile.',
        solution: 'A multi-surface streaming experience spanning live TV, VOD, monetization, personalization and mobile delivery.',
        role: 'Product engineering',
        architecture: 'Web and mobile surfaces for live and on-demand playback.',
        technologies: ['React', 'Node.js', 'Flutter'],
        challenges: '',
        result: '',
        image: '/work/Ayozat.png',
        images: ['/work/Ayozat.png'],
        links: [
            { label: 'Live', url: 'https://www.ayozat.com/' },
            { label: 'GitHub', url: 'https://github.com/lakshitha1629/Webview-Ayozat' },
        ],
        github: 'https://github.com/lakshitha1629/Webview-Ayozat',
        demo: 'https://www.ayozat.com/',
    },
    {
        id: 'zatlive',
        title: 'ZATLIVE',
        overline: 'Video & Broadband Platform · Tech Lead',
        category: 'Web',
        featured: true,
        problem: 'Video and broadband providers need one platform for immersive, customizable, interactive VOD, live streaming and ad monetization.',
        solution: 'Built the ZATLIVE platform, revolutionizing the video and broadband experience with immersive, customizable and interactive video services — VOD, live streaming, advanced playout, targeted ad insertion, customizable players and interactive overlays to boost viewer engagement.',
        role: 'Full Stack Developer & Tech Lead',
        architecture: 'Responsive Angular UI backed by REST APIs for VOD, live streaming and playout, Stripe for payments and ad monetization, brand-customizable video players, and interactive overlays (voting, player overlays) for audience engagement.',
        technologies: ['Angular', 'REST APIs', 'Stripe', 'Video Streaming'],
        challenges: '',
        result: '',
        image: '/work/Zatlive.png',
        images: ['/work/Zatlive.png'],
        links: [
            { label: 'Live', url: 'https://zatlive.com/' },
            { label: 'LinkedIn', url: 'https://www.linkedin.com/in/lakshitha1629/overlay/237729849/skill-associations-details/' },
        ],
        github: '',
        demo: 'https://zatlive.com/',
    },
    {
        id: 'delivery-route',
        title: 'Smart Delivery Routing',
        overline: 'Route Optimization Engine · Python',
        category: 'Backend',
        featured: true,
        problem: 'Find the nearest and fastest route for delivery drivers to deliver customer orders.',
        solution:
            'A cost-effective engine for vehicle routing optimization, using maps, OR-Tools and real-time messaging.',
        role: 'Full stack developer',
        architecture: 'Python services with Google Maps / Directions APIs, OR-Tools, Azure Service Bus and Azure Data Warehouse.',
        technologies: ['Python', 'OR-Tools', 'Google Maps', 'Azure Service Bus'],
        challenges: '',
        result: '',
        image: '/work/DeliveryRouteEngine.jpeg',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/a-star-shortest-path-with-google-maps-api' }],
        github: 'https://github.com/lakshitha1629/a-star-shortest-path-with-google-maps-api',
        demo: '',
    },
    {
        id: 'costcal',
        title: 'Delivery CostCal API',
        overline: 'Dotnet API Endpoint (ProjectXSpace)',
        category: 'Backend',
        featured: true,
        problem: 'Calculate distribution cost by distance, with separate options for mail delivery and delivery.',
        solution: 'An API that returns a delivery cost based on a given configuration.',
        role: 'Backend developer',
        architecture: '.NET API with SQL Server, Google API integration and Swagger documentation.',
        technologies: ['.NET', 'Google API', 'Swagger', 'SSMS'],
        challenges: '',
        result: '',
        image: 'https://i.imgur.com/UaxqLxY.jpg',
        links: [],
        github: '',
        demo: '',
    },
    {
        id: 'shrimp',
        title: 'Shrimp Counter',
        overline: 'Computer Vision App · BevyLabs',
        category: 'AI / ML',
        featured: true,
        problem: 'Count shrimp and shrimp clusters through a magnifier or microscope without doing it by hand.',
        solution:
            'A computer-vision proof of concept that detects shrimp and shrimp clusters in the browser.',
        role: 'Developer and Designer',
        architecture: 'Vue.js application using OpenCV.js, with Firebase and Heroku.',
        technologies: ['Vue.js', 'OpenCV.js', 'Firebase', 'Heroku'],
        challenges: '',
        result: '',
        image: '/work/Shrimp.png',
        links: [
            {
                label: 'Play Store',
                url: 'https://play.google.com/store/apps/details?id=org.bevylabs.shrimpvision&hl=en_IN',
            },
            { label: 'GitHub', url: 'https://github.com/lakshitha1629/fishcount' },
        ],
        github: 'https://github.com/lakshitha1629/fishcount',
        demo: 'https://play.google.com/store/apps/details?id=org.bevylabs.shrimpvision&hl=en_IN',
    },
    {
        id: 'phishnet',
        title: 'PhishNet',
        overline: 'Machine learning · Research',
        category: 'AI / ML',
        featured: true,
        problem: 'Phishing remains a practical security problem that can be approached with applied machine learning.',
        solution: 'A deep-learning project for phishing detection.',
        role: 'Machine learning · Research',
        architecture: 'Python and Jupyter-based deep learning workflow.',
        technologies: ['Python', 'Deep learning', 'Jupyter'],
        challenges: '',
        result: '',
        image: '',
        links: [
            {
                label: 'GitHub',
                url: 'https://github.com/lakshitha1629/PhishNet_Deep_Learning_for_Phishing_Detection',
            },
        ],
        github: 'https://github.com/lakshitha1629/PhishNet_Deep_Learning_for_Phishing_Detection',
        demo: '',
    },
    {
        id: 'rightsmint',
        title: 'RightsMint',
        overline: 'Web3 Royalty Marketplace',
        category: 'Web',
        featured: true,
        problem: 'Intellectual-property ownership is difficult to split and transact.',
        solution: 'A platform exploring fractional intellectual-property ownership with Solana smart contracts and secure APIs.',
        role: 'Full stack',
        architecture: 'Solana smart contracts with supporting APIs.',
        technologies: ['Solana', 'Smart contracts', 'APIs'],
        challenges: '',
        result: '',
        image: '/work/Rightsmint.png',
        images: ['/work/Rightsmint.png'],
        links: [
            { label: 'Live', url: 'https://rightsmint.com/' },
            { label: 'GitHub', url: 'https://github.com/lakshitha1629/metaplex' },
        ],
        github: 'https://github.com/lakshitha1629/metaplex',
        demo: 'https://rightsmint.com/',
    },
    {
        id: 'python-sinhala',
        title: 'Python Sinhala',
        overline: 'Learn-to-Code App · BevyLabs',
        category: 'Mobile',
        featured: false,
        problem: 'People who want to learn Python do not always have a computer nearby.',
        solution: 'A Python interpreter on Android so practice can happen anytime, anywhere.',
        role: 'Developer',
        architecture: 'Android application with Firebase and push notifications.',
        technologies: ['Android', 'Firebase'],
        challenges: '',
        result: '',
        image: 'https://i.imgur.com/FP5RrAa.jpg',
        links: [
            {
                label: 'Play Store',
                url: 'https://play.google.com/store/apps/details?id=bevylabs.buddhika.pythonsinhala&hl=en_US&gl=US',
            },
        ],
        github: '',
        demo: 'https://play.google.com/store/apps/details?id=bevylabs.buddhika.pythonsinhala&hl=en_US&gl=US',
    },
    {
        id: 'pascal-sinhala',
        title: 'Pascal Sinhala',
        overline: 'Learn-to-Code App · BevyLabs',
        category: 'Mobile',
        featured: false,
        problem: 'Sinhala-speaking beginners need an easy, native-language way to learn the Pascal programming language.',
        solution: 'A mobile tutorial app that teaches Pascal programming in Sinhala, with structured step-by-step lessons and runnable code examples.',
        role: 'Developer',
        architecture: 'Android application with an in-app Pascal runner and structured Sinhala-language lessons.',
        technologies: ['Android', 'Pascal', 'Firebase'],
        challenges: '',
        result: '',
        image: '/work/PascalSinhala.png',
        images: ['/work/PascalSinhala.png'],
        links: [],
        github: '',
        demo: '',
    },
    {
        id: 'ona',
        title: 'Ona.lk',
        overline: 'Classifieds Marketplace · Full Stack',
        category: 'Web',
        featured: false,
        problem: 'Classified advertising needs a modular, responsive web application.',
        solution: 'A classified ads web application with a fully responsive design and a large feature set.',
        role: 'Developer',
        architecture: 'Laravel, MySQL, Bootstrap and JavaScript.',
        technologies: ['PHP', 'Laravel', 'JavaScript', 'MySQL', 'Bootstrap'],
        challenges: '',
        result: '',
        image: 'https://i.imgur.com/rKsooV5.png',
        links: [{ label: 'Live', url: 'https://ona.lk/' }],
        github: '',
        demo: 'https://ona.lk/',
    },
    {
        id: 'on-air-tracker',
        title: 'New On-Air Sites Tracker',
        overline: 'Web Application (Mobitel — internship)',
        category: 'Web',
        featured: false,
        problem: 'Track a site from definition through configuration until it is on-air.',
        solution: 'An internal tracker for that operational process.',
        role: 'Full stack developer',
        architecture: 'Laravel with Bootstrap, SCSS, jQuery, JavaScript and HeidiSQL.',
        technologies: ['Laravel', 'Bootstrap', 'SCSS', 'jQuery'],
        challenges: '',
        result: '',
        image: 'https://i.imgur.com/TfvQh3L.png',
        links: [],
        github: '',
        demo: '',
    },
    {
        id: 'cell-block',
        title: 'Cell Block Manager',
        overline: 'Web Application (Mobitel — internship)',
        category: 'Web',
        featured: false,
        problem: 'Communicate block and deblock of site cells.',
        solution: 'An internal system for that operational communication.',
        role: 'Full stack developer',
        architecture: 'PHP with Bootstrap, Sass, jQuery, JavaScript and MySQL.',
        technologies: ['PHP', 'Bootstrap', 'Sass', 'MySQL'],
        challenges: '',
        result: '',
        image: 'https://i.imgur.com/3SwBPdd.png',
        links: [],
        github: '',
        demo: '',
    },
    {
        id: 'weddings',
        title: 'Weddings by Shanaka',
        overline: 'Photography Studio Website',
        category: 'Web',
        featured: false,
        problem: 'A wedding photographer needed a simple personal site.',
        solution: 'A straightforward wedding photography website for a client.',
        role: 'Developer',
        architecture: 'PHP, HTML, MySQL, Bootstrap and JavaScript.',
        technologies: ['HTML', 'PHP', 'Bootstrap', 'MySQL', 'JavaScript'],
        challenges: '',
        result: '',
        image: '/work/WeddingsByShanaka.jpg',
        links: [{ label: 'Live', url: 'http://weddingsbyshanaka.com/' }],
        github: '',
        demo: 'http://weddingsbyshanaka.com/',
    },
    {
        id: 'measure-distances',
        title: 'Measure Distances AI',
        overline: 'Computer vision',
        category: 'AI / ML',
        featured: false,
        problem: 'Calibrate key measurements with a phone and reduce the complexity of getting useful results.',
        solution: 'A system that uses machine learning and computer vision to automate measurement.',
        role: 'Developer',
        architecture: 'Angular frontend with OpenCV.js and Python / Flask.',
        technologies: ['Angular', 'OpenCV.js', 'Python', 'Flask'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/MeasureDistances-AI' }],
        github: 'https://github.com/lakshitha1629/MeasureDistances-AI',
        demo: '',
    },
    {
        id: 'movement-ai',
        title: 'Movements Assessment AI',
        overline: 'Machine learning',
        category: 'AI / ML',
        featured: false,
        problem: 'General movements assessment is time-consuming to do entirely by hand.',
        solution: 'An automated general movements assessment solution.',
        role: 'Developer',
        architecture: 'Angular with Python and Flask.',
        technologies: ['Angular', 'Python', 'Flask'],
        challenges: '',
        result: '',
        image: '',
        links: [
            { label: 'GitHub', url: 'https://github.com/lakshitha1629/MovementAssessment-AI' },
            { label: 'Live', url: 'https://nitagma.herokuapp.com/home' },
        ],
        github: 'https://github.com/lakshitha1629/MovementAssessment-AI',
        demo: 'https://nitagma.herokuapp.com/home',
    },
    {
        id: 'robo-arm',
        title: 'Robot Arm (MindWave & Kinect)',
        overline: 'Robotics · Full Stack Developer',
        category: 'AI / ML',
        featured: false,
        problem: 'Control a robotic hand remotely by capturing and replicating a person’s own hand motions.',
        solution: 'An automatic robotic hand that tracks and replicates the motions performed by the user’s own hand, enabling remote operation and control, built on MindWave and Kinect motion capture.',
        role: 'Full Stack Developer',
        architecture: 'MindWave and Kinect for motion tracking, Python and C++ control algorithms, Arduino microcontrollers driving the servos, plus a control interface and kinetic-typography visualization of the motion data.',
        technologies: ['Arduino', 'Python', 'C++', 'MindWave', 'Kinect'],
        challenges: '',
        result: '',
        image: '/work/RoboArm.png',
        images: ['/work/RoboArm.png'],
        links: [
            { label: 'MindWave', url: 'https://github.com/lakshitha1629/Robo_ARM_MindWave' },
            { label: 'Kinect', url: 'https://github.com/lakshitha1629/Robo_ARM_Kinect' },
        ],
        github: 'https://github.com/lakshitha1629/Robo_ARM_MindWave',
        demo: '',
    },
    {
        id: 'e-court',
        title: 'e-Court System',
        overline: 'Academic / systems',
        category: 'Backend',
        featured: false,
        problem: 'Court processes and case administration are difficult to run by hand.',
        solution: 'An e-court system that automates court processes and case administration.',
        role: 'Developer',
        architecture: '.NET Core with SQLite.',
        technologies: ['.NET Core', 'SQLite'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/CourtSystem' }],
        github: 'https://github.com/lakshitha1629/CourtSystem',
        demo: '',
    },
    {
        id: 'lsms',
        title: 'Lecture Schedules Management System',
        overline: 'Academic',
        category: 'Web',
        featured: false,
        problem: 'Lecturers and students need to manage schedules and find available halls or laboratories.',
        solution: 'A system for managing lecture schedules and discovering available rooms at a given time.',
        role: 'Developer',
        architecture: 'Java with MySQL.',
        technologies: ['Java', 'MySQL'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/LSMS' }],
        github: 'https://github.com/lakshitha1629/LSMS',
        demo: '',
    },
    {
        id: 'safylite',
        title: 'Safylite',
        overline: 'Tuition Class Management',
        category: 'Mobile',
        featured: false,
        problem: 'Parents need better visibility of students who may not have a smartphone.',
        solution:
            'A tuition-class system that can share location and sign-in/out times by SMS, with an Android application for those who have a phone.',
        role: 'Developer',
        architecture: 'Android, Java and PHP.',
        technologies: ['Android', 'Java', 'PHP'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/Safylite-Standalone-Software' }],
        github: 'https://github.com/lakshitha1629/Safylite-Standalone-Software',
        demo: '',
    },
    {
        id: 'hithumathe',
        title: 'Hithumathe Jeevithe',
        overline: 'Game',
        category: 'Mobile',
        featured: false,
        problem: '',
        solution: 'Sri Lanka’s first game with rap music. A platformer action game.',
        role: 'Developer',
        architecture: 'Unity with Autodesk SB.',
        technologies: ['Unity', 'Autodesk SB'],
        challenges: '',
        result: '',
        image: '',
        links: [
            { label: 'GitHub', url: 'https://github.com/lakshitha1629/Hithumathee-Jeewithe-Game' },
            { label: 'Play Store', url: 'https://play.google.com/store/apps/details?id=com.BevyLabs.Hethumathe' },
        ],
        github: 'https://github.com/lakshitha1629/Hithumathee-Jeewithe-Game',
        demo: 'https://play.google.com/store/apps/details?id=com.BevyLabs.Hethumathe',
    },
    {
        id: 'recycle-media',
        title: 'Recycle Media App',
        overline: 'Mobile Application',
        category: 'Mobile',
        featured: false,
        problem: 'People need a place to share DIY recycling work and plastic-awareness projects.',
        solution:
            'A social app for sharing creative recycle DIY projects, with comments and feedback on posts.',
        role: 'Developer',
        architecture: 'Android with Firebase.',
        technologies: ['Android', 'Firebase'],
        challenges: '',
        result: '',
        image: '',
        links: [
            {
                label: 'Play Store',
                url: 'https://play.google.com/store/apps/details?id=in.tvac.bevylabs.photoblog',
            },
        ],
        github: '',
        demo: 'https://play.google.com/store/apps/details?id=in.tvac.bevylabs.photoblog',
    },
    {
        id: 'hotel',
        title: 'Hotel Management System',
        overline: 'Web application',
        category: 'Web',
        featured: false,
        problem: 'Hotel guests need a way to reserve halls and rooms and compare packages.',
        solution: 'A web application that displays prices and package information according to preference.',
        role: 'Developer',
        architecture: 'HTML, CSS and JSP.',
        technologies: ['HTML', 'CSS', 'JSP'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/Hotel-Management-System' }],
        github: 'https://github.com/lakshitha1629/Hotel-Management-System',
        demo: '',
    },
    {
        id: 'marriage',
        title: 'Marriage Proposal Web Application',
        overline: 'Web application',
        category: 'Web',
        featured: false,
        problem: 'People need a way to filter and present proposal profiles by career, education and related details.',
        solution:
            'A web application where users can add profile details, be viewed by others, and display their own proposal advertisement.',
        role: 'Developer',
        architecture: 'PHP, jQuery and Bootstrap.',
        technologies: ['PHP', 'jQuery', 'Bootstrap'],
        challenges: '',
        result: '',
        image: '',
        links: [{ label: 'GitHub', url: 'https://github.com/lakshitha1629/Marriage-Proposal-Web-Application' }],
        github: 'https://github.com/lakshitha1629/Marriage-Proposal-Web-Application',
        demo: '',
    },
];

projects.forEach(project => {
    project.image = imageUrl(project.image);
    if (project.images) project.images = project.images.map(imageUrl);
});

export const featuredProjects = projects.filter((project) => project.featured);
export const archiveProjects = projects.filter((project) => !project.featured);

export default projects;
